<template>
  <div class="about-page">
    <!-- 页眉部分 -->
    <Header></Header>

    <!-- 导航菜单 -->
    <Nav></Nav>

    <!-- 英雄区域 -->
    <div class="hero">
      <div class="hero-content">
        <h1>联系我们</h1>
        <p>期待与您交流合作</p>
      </div>
    </div>

    <div class="main-content">
      <div class="contact-container">
        <!-- 左侧联系信息 -->
        <div class="contact-info">
          <h2 class="contact-title">联系方式</h2>

          <div class="contact-item">
            <div class="contact-label">
              <Icon size="20" type="md-pin" />地址
            </div>
            <p>广东省深圳市龙华区观澜街道观光路1234号科研楼A座5楼</p>
          </div>

          <div class="contact-item">
            <div class="contact-label">
              <Icon size="20" type="ios-call" />电话
            </div>
            <p>XXX-12345678（办公室）</p>
            <p>XXX-87654321（实验室）</p>
          </div>

          <div class="contact-item">
            <div class="contact-label">
              <Icon size="20" type="md-mail" />邮箱
            </div>
            <p>contact@xxx-lab.edu.cn（一般咨询）</p>
            <p>recruitment@xxx-lab.edu.cn（招聘咨询）</p>
            <p>cooperation@xxx-lab.edu.cn（合作咨询）</p>
          </div>

          <div class="contact-item">
            <div class="contact-label">
              <Icon size="20" type="md-clock" />办公时间
            </div>
            <p>周一至周五：9:00-17:00</p>
            <p>周末及节假日休息</p>
          </div>

          <div class="contact-item">
            <div class="contact-label">
              <Icon size="20" type="md-bus" />交通指南
            </div>
            <p>地铁：4号线观澜站B出口，步行10分钟</p>
            <p>公交：观光路站（123路、456路、789路）</p>
          </div>
        </div>

        <!-- 右侧联系表单 -->
        <div class="contact-form">
          <h2 class="form-title">发送消息</h2>
          <form @submit.prevent="handleSubmit">
            <div class="form-group">
              <label for="name" class="form-label">姓名</label>
              <input
                type="text"
                id="name"
                v-model="form.name"
                class="form-input"
                required />
            </div>

            <div class="form-group">
              <label for="email" class="form-label">邮箱</label>
              <input
                type="email"
                id="email"
                v-model="form.email"
                class="form-input"
                required />
            </div>

            <div class="form-group">
              <label for="phone" class="form-label">电话</label>
              <input
                type="tel"
                id="phone"
                v-model="form.phone"
                class="form-input" />
            </div>

            <div class="form-group">
              <label for="subject" class="form-label">主题</label>
              <select
                id="subject"
                v-model="form.subject"
                class="form-input"
                required>
                <option value="">请选择主题</option>
                <option value="research">科研合作</option>
                <option value="visit">参观访问</option>
                <option value="internship">实习申请</option>
                <option value="admission">招生咨询</option>
                <option value="other">其他</option>
              </select>
            </div>

            <div class="form-group">
              <label for="message" class="form-label">留言内容</label>
              <textarea
                id="message"
                v-model="form.message"
                class="form-input form-textarea"
                required></textarea>
            </div>

            <button type="submit" class="submit-btn" @click="sumbit()">
              发送消息
            </button>
          </form>
        </div>
      </div>
    </div>
    <!-- 页脚 -->
    <Footer></Footer>
  </div>
</template>

<script>
// import defaultLogo from "@/assets/default-logo.png";
import Header from "../../components/head.vue";
import Nav from "../../components/nav.vue";
import Footer from "../../components/footer.vue";

import { MessageAdd } from "../../api/contact";

export default {
  name: "ContactUs",
  components: { Header, Nav, Footer },
  data() {
    return {
      form: {
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      },
    };
  },
  methods: {
    async handleSubmit() {
      let res = await MessageAdd(this.form);
      if (res.code === 0) {
        alert("您的留言已发送！");
      } else {
        console.log(res.error);
      }

      // 清空表单
      this.form = {
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      };
    },
  },
};
</script>

<style scoped>
.hero {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="400"><rect width="1200" height="400" fill="%23004080"/><circle cx="200" cy="150" r="50" fill="%23FFD700" opacity="0.3"/><circle cx="800" cy="250" r="80" fill="%23FFD700" opacity="0.2"/><rect x="400" y="100" width="300" height="200" fill="%23FFD700" opacity="0.1"/></svg>');
  background-size: cover;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  padding: 0 20px;
}
.hero-content h1 {
  font-size: 2.5em;
  margin-bottom: 20px;
}
.hero-content p {
  font-size: 1.1em;
}

.main-content {
  max-width: 1200px;
  margin: 60px auto;
  padding: 0 20px;
}

.contact-container {
  display: flex;
  gap: 30px;
  justify-content: space-between;
}

.contact-info {
  width: 40%;
  background-color: #f8f9fa;
  padding: 30px 25px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.contact-form {
  width: 60%;
  background-color: white;
  padding: 25px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.contact-info:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.contact-title {
  color: #004080;
  font-weight: 700;
  font-size: 1.4em;
  margin-top: 0;
  margin-bottom: 25px;
  padding-bottom: 10px;
  border-bottom: 2px solid #004080;
  letter-spacing: 1px;
}

/* 联系信息项 */
.contact-item {
  margin-bottom: 20px;
  line-height: 1.6;
}

.contact-label {
  display: block;
  font-weight: bold;
  color: #004080;
  min-width: 90px;
  font-size: 0.95em;
  margin-bottom: 5px;
}

.contact-label p {
  margin: 0 1rem;
}

.contact-label i {
  margin-right: 0.8rem;
}

.contact-icon {
  color: #004080;
  font-size: 1.2em;
  margin-right: 8px;
  width: 20px;
  text-align: center;
}

.contact-item p {
  margin: 0;
  color: #333;
  font-size: 0.95em;
  flex: 1;
}

.form-group {
  margin-bottom: 15px;
}

.form-title {
  color: #004080;
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #004080;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  color: #555;
}

.form-input,
.form-textarea,
select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  transition: border-color 0.3s;
}

.form-textarea {
  min-height: 100px;
  resize: vertical;
}

.submit-btn {
  background-color: #004080;
  color: white;
  border: none;
  padding: 12px 25px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-btn:hover {
  background-color: #003366;
}

/* ==================== 响应式调整 ==================== */
@media (max-width: 768px) {
  .contact-info {
    padding: 20px;
    border-radius: 8px;
  }

  .contact-title {
    font-size: 1.4rem;
    text-align: center;
  }

  .contact-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .contact-label {
    min-width: auto;
  }
}
</style>
